var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDefaultMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.425 13.0425C13.23 12.4425 12.6675 12 12 12H11.25V9.75C11.25 9.55109 11.171 9.36032 11.0303 9.21967C10.8897 9.07902 10.6989 9 10.5 9H6V7.5H7.5C7.69891 7.5 7.88968 7.42098 8.03033 7.28033C8.17098 7.13968 8.25 6.94891 8.25 6.75V5.25H9.75C10.1478 5.25 10.5294 5.09196 10.8107 4.81066C11.092 4.52936 11.25 4.14782 11.25 3.75V3.4425C13.4475 4.3275 15 6.48 15 9C15 10.56 14.4 11.9775 13.425 13.0425ZM8.25 14.9475C5.2875 14.58 3 12.06 3 9C3 8.535 3.06 8.085 3.1575 7.6575L6.75 11.25V12C6.75 12.3978 6.90804 12.7794 7.18934 13.0607C7.47064 13.342 7.85218 13.5 8.25 13.5V14.9475ZM9 1.5C8.01509 1.5 7.03982 1.69399 6.12987 2.0709C5.21993 2.44781 4.39314 3.00026 3.6967 3.6967C2.29018 5.10322 1.5 7.01088 1.5 9C1.5 10.9891 2.29018 12.8968 3.6967 14.3033C4.39314 14.9997 5.21993 15.5522 6.12987 15.9291C7.03982 16.306 8.01509 16.5 9 16.5C10.9891 16.5 12.8968 15.7098 14.3033 14.3033C15.7098 12.8968 16.5 10.9891 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98491 1.5 9 1.5V1.5Z",
    fill: "#354052"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultMode);
export default __webpack_public_path__ + "static/media/ic-defaultMode.458d70a1037b3d022ce4b04463a5ff21.svg";
export { ForwardRef as ReactComponent };